<template>
  <ontos-base v-bind="baseProps" ref="base">
    <v-form v-if="loaded">
      <ontos-page-header v-bind="heading"/>
      <v-row>
        <v-col cols="12">
          <ontos-workflow-input ref="input" :value="workflowOnChange" @input="workflowOnChange = $event" :workflows="workspace.workflows" fixed-alias/>
        </v-col>
        <v-col cols="12" class="text-right">
          <v-btn size="small" color="primary" @click="save()" :disabled="edit.unchanged">
            <v-icon start>mdi-content-save</v-icon>
            {{ $tt('save') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </ontos-base>
</template>
<script lang="ts">
import {Component, toNative} from 'vue-facing-decorator'
import WorkflowInput from "@/components/design/workflow/WorkflowInput.vue";
import {NotFoundError} from "@/errors/errors";
import {DraftState, draftState} from "@/utils/modelUtils";
import Workflow, {emptyWorkflow} from "@/types/Workflow";
import {deepCopy} from "@/utils/copy";
import WorkflowLevelRouteComponent from "@/components/shared/WorkflowLevelRouteComponent";
import {workflowDesign} from "@/utils/heading";
import {citingFormulasMessage} from "@/utils/domainErrors";

@Component({components: {'ontos-workflow-input': WorkflowInput}})
class EditClass extends WorkflowLevelRouteComponent {
  get heading() {
    return workflowDesign(this.workflow!)
  }

  workflowOnChange: Workflow = emptyWorkflow()
  declare $refs: {input: InstanceType<typeof WorkflowInput>}

  async load() {
    try {
      this.workflowOnChange = deepCopy(this.workflow) //copia e deixa reativa
    } catch (err) {
      if (err instanceof NotFoundError) await this.$router.push({name: 'home'})
      else this.throwError(this.$tt('error.load-workflow', {name: this.$route.params.workflow}), err)
    }
  }

  async save() {
    const input = this.$refs.input;
    try {
        if (input.validateModel()) {
          await this.updateCurrentWorkflow(this.edit.changes)
          this.info(this.$tt('info.workflow-updated', {name: this.workflow.name}))
          await this.$router.push({name: 'view-workflow', params: {...this.$route.params, workflow: this.workflow.alias}})
        }
    } catch (err) {
      this.throwError(citingFormulasMessage(err) || this.$tt('error.update-workflow', {name: this.workflow.name}), err)
    }
  }

  /** O que mudou e se o salvar habilita — a regra mora no `draftState` */
  get edit(): DraftState {
    return draftState(this.workflow, this.workflowOnChange)
  }
}


export default toNative(EditClass)
</script>